import axios from 'axios';
import { Tag, Typography, Popconfirm, message, Spin, Modal, Button, Row, Col, Card } from 'antd';
import {
  CloseOutlined,
  CheckCircleOutlined,
  DragOutlined
} from '@ant-design/icons';

export default {
  getInviteInfo: async function (setFuncMap) {
    try {
      const res = await this.getInviteInfoAction()
      setFuncMap.setInviteInfo(res.data)
      setFuncMap.setIsPageLoading(false)
    } catch (error) {
    }
  },
  getInviteInfoAction: () => {
    return axios({
      method: 'GET',
      url: `/site/invite-info`
    })
  }
};
